export const UMB_DATA_TYPE_ENTITY_TYPE = 'data-type';
export const UMB_DATA_TYPE_ROOT_ENTITY_TYPE = 'data-type-root';
export const UMB_DATA_TYPE_FOLDER_ENTITY_TYPE = 'data-type-folder';

export type UmbDataTypeEntityType = typeof UMB_DATA_TYPE_ENTITY_TYPE;
export type UmbDataTypeRootEntityType = typeof UMB_DATA_TYPE_ROOT_ENTITY_TYPE;
export type UmbDataTypeFolderEntityType = typeof UMB_DATA_TYPE_FOLDER_ENTITY_TYPE;
